import { createFileRoute } from '@tanstack/react-router';

import { UnauthorizedPage } from '~/modules/router/components';

export const Route = createFileRoute('/unauthorized')({
  component: UnauthorizedPage,
});
